import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4f6nw7dny: FaireProductEntity = {
  token: "p_f4f6nw7dny",
  type: "product",
  name: "Women's Warm Chunky Ribbed Plush Beanie",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/377385a0bba0c8886cfd17ba23b9e5e548354820ec95e84111cf98aef92f53b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a59e47abf38f6e03f2ff8a888c17ed75e677b8d750893f11c66982598309b437.jpeg",
    "https://cdn.faire.com/fastly/61aff642597a659a55016958d587811a8c7eec3ce9013ac7a25b2a4c09fd98e1.jpeg",
    "https://cdn.faire.com/fastly/066d4b55dcffeaf0f43be60e400220e7638ac69fac19c23689e6dd697a15a24a.jpeg"
  ],
  priceDollars: 20,
  description: "Softies' cuffed beanie is luxuriously soft and crafted to wrap your ears in unmatched comfort. Stay toasty at home or enjoy an outdoor walk knowing that the buttery-soft marshmallow fabric won’t irritate your skin. Its cozy fit holds in your body heat to keep the warmth in and the cool air out. You just might need one of these stylist hats in every color!\n\nCozy, cute and a compliment to the entire closet.&nbsp; Snug fit to hold in warmth\nCuffed, ribbed marshmallow fabric is incredibly soft and comfortable\nAvailable in several colors, solid or heathered, and a gift giving favorite at one-size fits all!",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:12.195Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
